const reducer = (state, { giftVoucher }) => ({
  ...state,
  giftVoucherToRemove: giftVoucher,
  waiting: true,
});

export default reducer;
